export default __webpack_public_path__ + "static/media/foam-roller.5d88fad9.svg";